import { ListColumn } from "./ListColumn";
import { ListView } from "./ListView";

export class DynamicListView extends ListView {

    itemFinderArrayColumns: ListColumn[];
    itemFinderTreeColumns: ListColumn[];


    constructor(items: any, fieldsToRetrieve: ListColumn[]) {
        super();
        const itemsWithChecked = items.map((info: any) => ({ checked: false, ...info }));
        this.model = itemsWithChecked; // checked false by default

        this.itemFinderArrayColumns = fieldsToRetrieve;
        this.itemFinderTreeColumns = fieldsToRetrieve;
    }


}